var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.33333L9 3.33333M9 3.33333C9 4.4379 9.89543 5.33333 11 5.33333C12.1046 5.33333 13 4.4379 13 3.33333C13 2.22876 12.1046 1.33333 11 1.33333C9.89543 1.33333 9 2.22876 9 3.33333ZM5 8.66667L13 8.66667M5 8.66667C5 9.77124 4.10457 10.6667 3 10.6667C1.89543 10.6667 1 9.77124 1 8.66667C1 7.5621 1.89543 6.66667 3 6.66667C4.10457 6.66667 5 7.5621 5 8.66667Z",
    stroke: "#667BA3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.069356426c8766460f06ca7b4191090b.svg";
export { ForwardRef as ReactComponent };